import React from 'react';
import PropTypes from 'prop-types';
import useCmsImage from '@utils/useCmsImage';
import { Ta11yImage } from '@core/index';

export const Logo = ({ variant = 'light', height = "77px" }) => {
  const imageLightContentLogo = useCmsImage('ek_start_logo_light_content-1');
  const imageBlueContentLogo = useCmsImage('ek_start_logo_content-1');

  const imgContentMap = {
    light: imageLightContentLogo,
    blue: imageBlueContentLogo
  };

  return (
    <>
      <Ta11yImage
        imageContent={imgContentMap[variant] || imageLightContentLogo}
        style={{ height: height }}
      />
    </>
  );
};

Logo.propTypes = {
  variant: PropTypes.oneOf(['light', 'blue']),
  height: PropTypes.string
};

export default Logo;
